export default __webpack_public_path__ + "static/media/invalid-name.a31524fe.webp";